export default Object.freeze({
  AED: 'AED',
  EGP: 'EGP',
  EUR: 'EUR',
  USD: 'USD',
});
